import { ACTION_TYPES } from '@/actions';
import { judgeHasNextPage, getPagingList } from "@/core/util";

const INIT_STATE = {
  hasMore: true,
  records: []
};

export default function orderList(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    // 获取订单列表(分页)
    case ACTION_TYPES.GET_ORDER_PAGING_LIST:
      result.hasMore = judgeHasNextPage(payload);
      result.records = getPagingList(result.records, payload);
      break;
    default:
      result = state;
  }
  return result;
}
